import { _get, _post, _put } from "../../../../apiClient";
import moment from 'moment';
import { _showToast } from "../../../../toastHelper";
import config from "../../../../config";
import { deleteImages, uploadImage } from "../../../Services/ImageService";
import { keyboard } from "@testing-library/user-event/dist/keyboard";

let profileJson;
let deletedKeys = [];
let imageCount = 0;
let videoCount = 0;

export default async function Save(sections, themeId, eventId, eventCode, deletedImages) {
    profileJson = {};
    deletedKeys = [...deletedImages]
    profileJson.version = "1.0";
    profileJson.studioId = "";
    imageCount = 0;
    videoCount = 0;

    if (sections && sections.length > 0) {
        let isValid = true;
        sections.forEach(section => {
            if (!section.isValid)
                isValid = false;
        });

        if (isValid) {
            if (!eventCode || (eventCode && eventCode == ""))
                eventCode = await getEventCode();
            if (eventCode && eventCode != "") {
                if (await checkImageAndVideoStatus(sections, eventCode)) {
                    for (const section of sections) {
                        if (section.sectionname == "seo") {
                            if (!await processingSeoDetails(section, eventCode)) {
                                profileJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "about") {
                            if (!await processingAboutDetails(section, eventCode)) {
                                profileJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "services") {
                            if (!await processingServices(section, eventCode)) {
                                profileJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "gallery") {
                            if (!await processingGallery(section, eventCode)) {
                                profileJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "studio") {
                            profileJson.studioId = section.data;
                        }
                        else if (section.sectionname == "theme") {
                            if (!await processingCustomization(section, eventCode)) {
                                profileJson = null;
                                break;
                            }
                        }
                    }
                    if (!eventId || (eventId && eventId == 0))

                        return await createProfile(eventCode, themeId);
                    else
                        return await updateProfile(eventId, eventCode);

                }
                else {
                    return {
                        status: "failed",
                        message: ""
                    };
                }
            }

            return {
                status: "failed",
                message: "Unable to process your request"
            };
        }
        return {
            status: "failed",
            message: "Please provide data for all the required fields before saving"
        };
    }
}

const createProfile = async (eventCode, themeId) => {
    if (profileJson) {
        let postdata = {
            code: eventCode,
            themeId: parseInt(themeId, 10),
            categoryId: parseInt(config.websiteCategoryId, 10),
            title: profileJson.seo.title,
            description: profileJson.seo.description,
            keywords: profileJson.seo.keywords,
            thumbnail: profileJson.seo.imageKey,
            studioId: profileJson.studioId,
            jsonData: JSON.stringify(profileJson),
            imageCount: imageCount,
            videoCount: videoCount,
        }

        return await _post("/profile-pages", postdata)
            .then(async (response) => {
                await deleteImages(deletedKeys);
                deletedKeys = [];
                return {
                    status: "success",
                    websiteCode: postdata.code,
                    websiteId: response.id,
                    websiteUrl: response.url,
                    message: "Website created successfully"
                };
            })
            .catch((error) => {
                return {
                    status: "failed",
                    message: error
                };
            });
    }
}

const updateProfile = async (eventId, eventCode) => {
    if (profileJson) {
        let postdata = {
            id: eventId,
            title: profileJson.seo.title,
            description: profileJson.seo.description,
            keywords: profileJson.seo.keywords,
            thumbnail: profileJson.seo.imageKey,
            studioId: profileJson.studioId,
            jsonData: JSON.stringify(profileJson),
            imageCount: imageCount,
            videoCount: videoCount
        }

        return await _put("/profile-pages", postdata)
            .then(async (response) => {
                await deleteImages(deletedKeys);
                deletedKeys = [];
                return {
                    status: "success",
                    websiteCode: postdata.code,
                    websiteId: response.id,
                    websiteUrl: response.url,
                    message: "Website updated successfully"
                };
            })
            .catch((error) => {
                return {
                    status: "failed",
                    message: error
                };
            });
    }
}

const getEventCode = async () => {
    return await _get("/profile-pages/code/10")
        .then((response) => {
            return response
        })
        .catch((error) => {
            _showToast(error, "error");
            return "";
        })
}

const checkImageAndVideoStatus = async (sections, eventCode) => {
    getImageAndVideoCount(sections);

    if (imageCount > 0 || videoCount > 0) {
        return await _get(`/uploads/check-upload-status?eventCode=${eventCode}&imageCount=${imageCount}&videoCount=${videoCount}&studioProfileId=0`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                _showToast(error, "error");
                return false;
            });
    }
    else
        return true;
}

const getImageAndVideoCount = async (sections) => {
    sections.forEach((section) => {
        if (section.data && Array.isArray(section.data)) {

            section.data.forEach((data) => {
                if ((data.imageKey && data.imageKey != "") || (data.imageFile && data.imageFile != null)) {
                    imageCount = imageCount + 1;
                }

                if ((data.videoUrl && data.videoUrl != "")) {
                    videoCount = videoCount + 1;
                }
            })
        }
        else {
            if ((section.data.imageKey && section.data.imageKey != "") || (section.data.imageFile && section.data.imageFile != null)) {
                imageCount = imageCount + 1;
            }

            if ((section.data.youtubeLink && section.data.youtubeLink != "")) {
                videoCount = videoCount + 1;
            }
        }
    });
}

const processingSeoDetails = async (section, eventCode) => {
    let path = "";
    if (section.data.imageFile) {
        path = await uploadImage(`profile-data/${eventCode}`, section.data.imageFile, eventCode, "ProfileThumb");
        if (!path || (path && path == ""))
            return false;

        if (section.data.imageKey && section.data.imageKey != "") {
            deletedKeys.push(section.data.imageKey);
        }
        section.data.imageFile = null;
        section.data.image = config.imagesbaseurl + path;
        section.data.imageKey = path;
    }

    profileJson.seo = {
        title: section.data.title,
        description: section.data.description,
        keywords: section.data.keywords,
        imageKey: section.data.imageKey,
    }
    return true;
}
const processingAboutDetails = async (section, eventCode) => {
    let path = "";
    if (section.data.imageFile) {
        path = await uploadImage(`profile-data/${eventCode}`, section.data.imageFile, eventCode, "AboutThumb");
        if (!path || (path && path == ""))
            return false;

        if (section.data.imageKey && section.data.imageKey != "") {
            deletedKeys.push(section.data.imageKey);
        }
        section.data.imageFile = null;
        section.data.image = config.imagesbaseurl + path;
        section.data.imageKey = path;
    }

    profileJson.about = {
        description: section.data.description,
        featuredTitle: section.data.featuredTitle,
        featuredDescription: section.data.featuredDescription,
        imageKey: section.data.imageKey
    }

    return true;
}


const processingServices = async (section, eventCode) => {

    profileJson.services = [];
    for (const service of section.data) {
        profileJson.services.push({
            title: service.title,
            description: service.description,
            serviceLink: service.serviceLink
        });
    }
    return true;
}

const processingGallery = async (section, eventCode) => {
    profileJson.gallery = [];
    let datas = [];
    for (const galleryItem of section.data) {
        if (galleryItem.imageFile) {
            let path = await uploadImage(`profile-data/${eventCode}/gallery`, galleryItem.imageFile, eventCode, "ProfileGallery");
            if (!path || (path && path == ""))
                return false;

            if (galleryItem.imageKey && galleryItem.imageKey != "") {
                deletedKeys.push(galleryItem.imageKey);
            }
            galleryItem.image = config.imagesbaseurl + path;
            galleryItem.imageFile = null;
            galleryItem.imageKey = path;
        }

        profileJson.gallery.push({
            fileId: galleryItem.fileId,
            name: galleryItem.name,
            imageKey: galleryItem.imageKey,
            type: galleryItem.type,
            videoUrl: galleryItem.videoUrl,
            videoImage: galleryItem.videoImage,
            isPrimaryVideo: galleryItem.isPrimaryVideo
        });
        datas.push(galleryItem);
    }

    section.data = datas;
    return true;
}


const processingCustomization = async (section, eventCode) => {
    profileJson.sliders = [];
    let datas = [];
    for (const slider of section.data) {
        if (slider.imageFile) {
            let path = await uploadImage(`profile-data/${eventCode}/sliders`, slider.imageFile, eventCode, "ProfileBanners");
            if (!path || (path && path == ""))
                return false;

            if (slider.imageKey && slider.imageKey != "") {
                deletedKeys.push(slider.imageKey);
            }
            slider.image = config.imagesbaseurl + path;
            slider.imageFile = null;
            slider.imageKey = path;
        }
        profileJson.sliders.push({
            imageKey: slider.imageKey
        });
        datas.push(slider);
    }
    section.data = datas;
    return true;
}